import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row, Layout, Button, Divider, Tag } from "antd";
import {
  BarChartOutlined,
  CarOutlined,
  CloseCircleFilled,
  DollarOutlined,
  FileAddOutlined,
  FileMarkdownOutlined,
  FilePptOutlined,
  HomeOutlined,
  ShopOutlined,
  StockOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { removeTokenFromCookies } from "../../utils/cookies";
import "./Sidebar.css";
import Cookies from "universal-cookie";

const { Sider } = Layout;

export interface SidebarProps {
  collapsed: boolean;
  toggleSidebar: (collapsed: boolean) => void;
}

const Sidebar = (props: SidebarProps) => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const userRole = cookies.get("USER_ROLE");
  const userID = cookies.get("USER_ID");
  const currOffice = cookies.get("CURR_OFFICE");
  const officeInfo: any = {
    pg: { className: "pg-office", name: "Penang Office ( PG )" },
    bw: { className: "bw-office", name: "Butterworth Office ( BW )" },
  };

  const navToNewPurchase = () => {
    navigate(`/newpurchase`);
  };

  const navToPurchases = () => {
    navigate(`/purchases`);
  };

  const navToBills = () => {
    navigate(`/bills`);
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const navToSuppliers = () => {
    navigate("/suppliers");
  };

  const navToBuyers = () => {
    navigate("/buyers");
  };

  const navToMetalsList = () => {
    navigate("/metals");
  };

  const navToSummary = () => {
    navigate("/summary");
  };

  const navToInventory = () => {
    navigate("/inventory");
  };

  const navToMaterials = () => {
    navigate("/materials");
  };

  const logout = () => {
    removeTokenFromCookies();
    navToLogin();
  };

  const navToNewBundle = () => {
    navigate("/newbundle");
  };

  const navToNewShipment = () => {
    navigate("/newshipment");
  };

  const navToShipments = () => {
    navigate("/shipments");
  };

  const navToShipmentsMaterials = () => {
    navigate("/shipmentsmaterials");
  };

  const navToBundles = () => {
    navigate("/bundles");
  };

  const navToAveragePrices = () => {
    navigate("/averageprices");
  };

  const navToOverview = () => {
    navigate("/overview");
  };

  const navToOverviewMaterials = () => {
    navigate("/overviewmaterials");
  };

  const navToSales = () => {
    navigate("/sales");
  };

  const navToInvoices = () => {
    navigate("/invoices");
  };

  const navToNewSale = () => {
    navigate("/newsale");
  };

  const navToSalesMaterials = () => {
    navigate("/salesmaterials");
  };

  const navToHome = () => {
    navigate("/");
  };

  return (
    <Sider className="sider" trigger={null} collapsible collapsed={props.collapsed} collapsedWidth={0} width={300}>
      <Row style={{ height: "100lvh" }}>
        <Col span={24}>
          <Row justify="end">
            <CloseCircleFilled onClick={() => props.toggleSidebar(true)} className="sider-close-icon" />
          </Row>
          <Row style={{ margin: "20px" }} justify="space-around">
            <h2 className="sider-title">Metals Trading</h2>
          </Row>
          <Row justify="center" style={{ marginBottom: "30px" }}>
            {currOffice === "" || currOffice === undefined ? (
              <Button
                onClick={() => navToHome()}
                icon={<ShopOutlined />}
                style={{ fontWeight: "bold", width: "80%" }}
                className="select-office"
              >
                Select an Office
              </Button>
            ) : (
              <Tag
                icon={<ShopOutlined />}
                color="default"
                className={
                  officeInfo[currOffice] === undefined || officeInfo[currOffice] === null
                    ? ""
                    : officeInfo[currOffice].className
                }
              >
                {officeInfo[currOffice] === undefined || officeInfo[currOffice] === null
                  ? ""
                  : officeInfo[currOffice].name}
              </Tag>
            )}
          </Row>
          <Row justify="center">
            <Col span={18}>
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToNewPurchase} icon={<FileAddOutlined />}>
                  New Purchase
                </Button>
              </Row>
              {/* <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToNewBundle} icon={<FileAddOutlined />}>
                  New Bundle
                </Button>
              </Row> */}
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToNewShipment} icon={<FileAddOutlined />}>
                  New Shipment
                </Button>
              </Row>
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToNewSale} icon={<FileAddOutlined />}>
                  New Sale
                </Button>
              </Row>
              <Divider style={{ margin: "5px 0", backgroundColor: "white" }} />
              <>
                <Row justify="start">
                  <Button type="link" className="sider-button" onClick={navToBills} icon={<DollarOutlined />}>
                    Bills
                  </Button>
                </Row>
              </>
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToPurchases} icon={<FilePptOutlined />}>
                  Purchases
                </Button>
              </Row>
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToMaterials} icon={<FileMarkdownOutlined />}>
                  Purchases Materials
                </Button>
              </Row>
              <Divider style={{ margin: "5px 0", backgroundColor: "white" }} />
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToInvoices} icon={<DollarOutlined />}>
                  Invoices
                </Button>
              </Row>
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToSales} icon={<FilePptOutlined />}>
                  Sales
                </Button>
              </Row>
              <Row justify="start">
                <Button
                  type="link"
                  className="sider-button"
                  onClick={navToSalesMaterials}
                  icon={<FileMarkdownOutlined />}
                >
                  Sales Materials
                </Button>
              </Row>
              <Divider style={{ margin: "5px 0", backgroundColor: "white" }} />
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToInventory} icon={<StockOutlined />}>
                  Inventory
                </Button>
              </Row>
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToShipments} icon={<FileMarkdownOutlined />}>
                  Shipments
                </Button>
              </Row>
              <Row justify="start">
                <Button
                  type="link"
                  className="sider-button"
                  onClick={navToShipmentsMaterials}
                  icon={<FileMarkdownOutlined />}
                >
                  Shipments Materials
                </Button>
              </Row>
              {/* <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToBundles} icon={<FileMarkdownOutlined />}>
                  Bundles
                </Button>
              </Row> */}
              <Divider style={{ margin: "5px 0", backgroundColor: "white" }} />
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToSuppliers} icon={<UsergroupAddOutlined />}>
                  Suppliers
                </Button>
              </Row>
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToBuyers} icon={<UsergroupAddOutlined />}>
                  Buyers
                </Button>
              </Row>
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToMetalsList}>
                  Metals List
                </Button>
              </Row>
              <Row justify="start">
                <Button type="link" className="sider-button" onClick={navToAveragePrices} icon={<DollarOutlined />}>
                  Average Prices
                </Button>
              </Row>
              {(userID === "333a7991-072c-4781-b54b-9bd83787007c" ||
                userID === "ce2cee02-8c4d-4ade-8992-f108acb4897d") && (
                <>
                  <Row justify="start">
                    <Button type="link" className="sider-button" onClick={navToOverview}>
                      Overview
                    </Button>
                  </Row>
                  <Row justify="start">
                    <Button type="link" className="sider-button" onClick={navToOverviewMaterials}>
                      Overview Materials
                    </Button>
                  </Row>
                </>
              )}
              {/* {userRole === "admin" && (
                <>
                  <Divider style={{ margin: "5px 0", backgroundColor: "white" }} />
                  <Row justify="start">
                    <Button type="link" className="sider-button" onClick={navToSummary} icon={<BarChartOutlined />}>
                      Summary
                    </Button>
                  </Row>
                </>
              )} */}
            </Col>
          </Row>

          <Row justify="space-around">
            <Button
              onClick={() => navToHome()}
              icon={<HomeOutlined />}
              style={{ fontWeight: "bold", position: "absolute", bottom: "80px" }}
            >
              Home
            </Button>
            <Button onClick={() => logout()} style={{ fontWeight: "bold", position: "absolute", bottom: "30px" }}>
              Logout
            </Button>
          </Row>
        </Col>
      </Row>
    </Sider>
  );
};

export default Sidebar;
